import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "圖層 1",
  viewBox: "0 0 77.31 78.01"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M33.49 36.62c.61-4.53-4.42-3.92-4.42-3.92.21-2.32 4.03-7.35 9.26-5.94 5.24 1.41 5.64 7.04 5.64 7.04C48.65 9.07 68.61 2.37 77.31.61V0H0v78.01h64.38c-36.26-6.27-30.89-41.4-30.89-41.4Z",
      style: {"fill":"#312667"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M60.36 42.94c-7.15-3.61-17-2.11-17-2.11 2.05 28.83 24.45 35.72 31.43 37.18h2.53V3.63C51.33 15.71 60.36 42.94 60.36 42.94Z",
      style: {"fill":"#e6001f"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "NX-logo"}) } }